const API_BASE = '/api/v1/public/projects';

// ── Response types ─────────────────────────────────────────────────────────────

export interface PlaceValueGroup {
  operation:       string;
  propertyType:    string;
  currency:        string;
  sampleCount:     number;
  priceRange:      { p25: number | null; median: number | null; p75: number | null };
  pricePerM2Range: { p25: number | null; median: number | null; p75: number | null } | null;
  ppm2SampleCount: number;
  confidenceLevel: 'low' | 'medium' | 'high';
  confidenceLabel: string;
  explanation:     string;
}

interface PlaceDto {
  scopeLabel:     string;
  contextMethod:  string;
  contextRadiusM: number;
}

interface MessagesDto {
  title:      string;
  summary:    string;
  disclaimer: string;
}

export interface PlaceValueAvailable {
  status:   'available';
  place:    PlaceDto;
  market:   { metricsVersion: string; updatedAt: string; groups: PlaceValueGroup[] };
  messages: MessagesDto;
  actions:  string[];
}

export interface PlaceValueUnavailable {
  status:   'insufficient_data';
  place:    PlaceDto;
  messages: MessagesDto;
}

export type PlaceValueResponse = PlaceValueAvailable | PlaceValueUnavailable;

// ── Fetch ──────────────────────────────────────────────────────────────────────

export interface PlaceValueFilters {
  operation?:     string;
  propertyType?:  string;
  currency?:      string;
  metricsVersion?: string;
}

export async function fetchPlaceValueNear(
  slug:    string,
  lng:     number,
  lat:     number,
  filters: PlaceValueFilters = {},
): Promise<PlaceValueResponse> {
  const params = new URLSearchParams({ lng: String(lng), lat: String(lat) });
  if (filters.operation)      params.set('operation',      filters.operation);
  if (filters.propertyType)   params.set('propertyType',   filters.propertyType);
  if (filters.currency)       params.set('currency',       filters.currency);
  if (filters.metricsVersion) params.set('metricsVersion', filters.metricsVersion);

  const res = await fetch(`${API_BASE}/${slug}/places/near?${params.toString()}`);
  if (!res.ok) throw new Error(`Ficha del lugar: error ${res.status}`);
  return res.json() as Promise<PlaceValueResponse>;
}
